(ns common.schema.entities.survey-reminder.core
  (:require
   [common.schema.entities.survey-reminder.permissions :as permissions]
   [common.schema.entities.survey-reminder.schema :as schema]))

(def entity-type-definition
  {:entity-type                  :entity.type/survey-reminder
   :schema                       schema/schema
   :name                         {:en "Survey reminder"}
   :plural                       {:en "Survey reminders"}
   :icon                         :fa-bell
   :display-name-template        "{{survey-reminder/reminder-status}}"
   :display-name/depends-on      [:survey-reminder/reminder-status]
   :permissions                  {:creatable?   true
                                  :disableable? true}
   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
